export default {
    data() {
        return {
            // make sure you update in classes/Onboarding.class.php as well
            TASK_TYPE_UPDATE_CONTACT_INFO: 'update_contact_info',
            TASK_TYPE_UPDATE_PROFILE_PHOTO: 'update_profile_photo',
            TASK_TYPE_UPLOAD_LOGO: 'upload_logo',
            TASK_TYPE_ADD_BIO: 'add_bio',
            TASK_TYPE_LAUNCH_WEBSITE: 'launch_website',
            TASK_TYPE_SETUP_SOCIAL_BRANDING: 'setup_social_branding',
            TASK_TYPE_GO_THROUGH_MARKETING_SETUP: 'go_through_marketing_setup',
            TASK_TYPE_RECEIVE_FIRST_REFERRAL_LEAD: 'receive_first_referral_lead',
            TASK_TYPE_UNIVERSITY_COURSE_LESSON: 'university_course_lesson',
            TASK_TYPE_ADD_SERVICE_AREA: 'add_service_area',
            TASK_TYPE_SETUP_RETARGETING: 'setup_retargeting',
            TASK_TYPE_SETUP_LEAD_GEN: 'setup_lead_gen',
            TASK_TYPE_WORK_FIRST_LEAD: 'work_first_lead',
            TASK_TYPE_GATHER_BILLING_INFO: 'gather_billing_info',
            TASK_TYPE_BOOK_APPOINTMENT: 'book_appointment',
            TASK_TYPE_ADD_BASIC_INFO: 'add_basic_info',
            TASK_TYPE_ONBOARDING_QUESTION: 'onboarding_question',
        }
    }
}